/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Page Cashback translation
 *
 * @author Yakov Gushchin
 * @author Julia Ignatieva
 * @author Nikolay Sviridov
 * @version 1.34.0
 * @since 1.12.0
 */
import { CashbackHistoryTableField } from '../../../../pages/PageCashback/types/cashbackHistoryTypes';
import { IPageCashbackTranslation } from '../../types/pages/cashback';

export const initPageCashbackTranslation: IPageCashbackTranslation = {
    account: '',
    error: {
        codes: {},
        defaultMessage: '',
    },
    notAvailable: {
        btn: '',
        text: '',
        title: '',
    },
    sideMenu: {
        control: '',
        history: '',
        info: '',
    },
    tabControl: {
        actionTooltipNotByAction: '',
        actionTooltipNotByRole: '',
        autoSpending: {
            anchorLink: '',
            howToGetCashbackLink: '',
            statusDisabled: '',
            statusEnabled: '',
            subTitle: '',
            switchLabel: '',
            title: '',
            tooltipNoServiceList: '',
        },
        btnActivation: '',
        btnReserve: '',
        btnTooltipNoActivationLink: '',
        btnTooltipNotChosen: '',
        reserveModal: {
            error: {
                title: '',
            },
            start: {
                btnReserve: '',
                checkboxReserveAll: '',
                inputPlaceholder: '',
                subTitle: '',
                title: '',
            },
            success: {
                btnRedirect: '',
                subTitle: '',
                title: '',
            },
        },
        scoreBalanceLost: '',
        scoreBalanceSubtitle: '',
        scoreError: '',
        scoreInfo: '',
        scoreReservedSubtitle: '',
        scoreReservedTooltip: '',
        scoreServiceTabAvailable: '',
        scoreServiceTabConnected: '',
        scoreServiceTitle: '',
        serviceCard: {
            moreLink: '',
            reserve: '',
        },
        statusError: {
            btn: '',
            title: '',
        },
        statusNoAvailableServices: {
            text: '',
            title: '',
        },
        statusNoConnectedServices: {
            btn: '',
            text: '',
            title: '',
            newTitle: '',
        },
        tabAvailable: '',
        tabConnected: '',
        title: '',
        newtitle: '',
    },
    tabHistory: {
        balanceSubtitle: '',
        table: {
            [CashbackHistoryTableField.date]: { header: '', dataName: '' },
            [CashbackHistoryTableField.operationType]: { header: '', dataName: '' },
            [CashbackHistoryTableField.scores]: { header: '', dataName: '' },
            [CashbackHistoryTableField.service]: { header: '', dataName: '' },
        },
        title: {
            dropFilters: '',
        },
    },
    cashbackServiceInfo: {
      title: '',
      infoHtmlText: '',
    },
    title: '',
};
